import Button from "./prop/Button"
import VideoPlayer from "./prop/VideoPlayer"

export default function Projets() {
    const numbers = Array.from({ length: 7 }, (_, i) => i + 1)


    return (
        <section className="projets-container container-pad">
            <div className="dernier-projet">
                <h2 className="sansita f48">
                    Notre <br />
                    Dernier site
                </h2>
                <VideoPlayer />
                <Button outline label='Contactez-nous' href="#contact"/>
            </div>
            <div className="overlay-container">
                <div className="overlay overlay-1"></div>
                <div className="overlay overlay-2"></div>
                <div className="overlay overlay-3"></div>
                
                <div className="nos-projets-container">
                    <div className="text">
                        <h3 className="f40 sansita">Plusieurs dizaines de projets réalisés</h3>
                        <p className="text-projet">Des solutions adaptées pour <br />
                            vos besoins réels.
                        </p>
                        <div className="btn-container">
                            <Button label='Appelez-nous' color='red' />
                            <Button label='Envoyez un mail' color='white' outline />
                        </div>
                    </div>

                    {numbers.map(id => (
                        <img key={id} src={`./img/site/site0${id}.jpg`} alt={`image site maestrom`} className={`img-site img-site-${id}`} />
                    ))}

                </div>
            </div>
        </section>
    )
}